import React from "react";
import SummaryOverview from "./SummaryOverview";
import OtherDetailsInput from "./OtherDetailsInput";
import EventTagsSelector from "./EventTagsSelector";

const ConfirmationStep = ({
  data,
  onChange,
  isEdit,
  changeReason,
  setChangeReason,
  hasChanged,
}) => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800">Review & Confirm</h2>

      <SummaryOverview data={data} />
      <EventTagsSelector selectedTags={data.tags || []} onChange={onChange} />
      <OtherDetailsInput
        otherDetails={data.otherDetails}
        onChange={(val) => onChange("otherDetails", val)}
      />
      {isEdit && (
        <div className="mt-4">
          <label
            htmlFor="change-reason"
            className="block text-sm font-medium text-red-600 mb-1"
          >
            {hasChanged
              ? "Please explain why changes are being made"
              : "No changes made yet!"}
          </label>
          <textarea
            id="change-reason"
            rows={4}
            value={changeReason}
            onChange={(e) => setChangeReason(e.target.value)}
            placeholder="Explain the reasoning behind the changes..."
            className="w-full rounded-md border border-gray-300 focus:border-blue-500 focus:ring-blue-500 shadow-sm px-3 py-2 text-sm text-gray-800"
          />
        </div>
      )}
    </div>
  );
};

export default ConfirmationStep;
